import { axios } from "../../../lib/axios";

export const GetTransactionsType = async (): Promise<any> => {
  const response = await axios.get("/transaction-types");
  return response.data;
};
